export default __webpack_public_path__ + "static/media/dragon_curve.8df7d3ff.gif";